import {Component}                            from '@angular/core';
import {Timestamp}                            from '@angular/fire/firestore';
import {CaffRecordLogIntf, CaffRecordSumIntf} from '@djsharkk/logr-types';
import {takeUntil}                            from 'rxjs/operators';
import {MenuCrudPanelContentBase}             from '../../menu-crud-panel-content-base';
import {MenuCrudPanelTopComponent}            from '../menu-crud-panel-top.component';

@Component({
			   selector   : 'app-menu-crud-caff',
			   imports    : [
				   MenuCrudPanelTopComponent
			   ],
			   templateUrl: './menu-crud-panel-caff-top.component.html',
			   styleUrl   : './menu-crud-panel-caff-top.component.css'
		   })
export class MenuCrudPanelCaffTopComponent extends MenuCrudPanelContentBase<CaffRecordLogIntf, CaffRecordSumIntf> {


	constructor() {
		super('caff', false);


		this.svcDataFactory.svcDataCaff.caffConfs
			.pipe(takeUntil(this.destroy$))
			.subscribe(confs => {
				this.recordConfBtns = confs.map((conf, index) => {
					// console.log(conf)
					return {
						uuid: conf.id as string,
						icon: `${index.toString().padStart(2, `0`)}`,
						text: [
							...conf.name.split(' '),
							`${conf.data.mg}mg`
						],
						func: () => {
							this.svcFirebaseTools.recCreate('caff_records_log', {
								...conf.data,
								timestamp: Timestamp.now()
							}).then(r => console.log('Caff Record Done'))
						}
					}
				}).sort((a, b) => a.text[0].localeCompare(b.text[0]))
			})


	}


}